import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import moment from "moment";

import { getDetails, resetField, deleteExerciseFromHistory } from "../../../store/actions";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";
import AddLogPanel from "../myProgress/addLogPanel";
import ConfirmDelete from "../../../sharedComponents/confirmDelete";
import Tooltip from "../../../sharedComponents/tooltip";

export const Details = ({ getDetails, detailsData, resetField, history, deleteExerciseFromHistory }) => {
	const [formValues, setFormValues] = useState({});
	const [deleteItem, setDeleteItem] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [params, setParams] = useState("limit=15");

	useEffect(() => {
		getDetails(`?${params}`);
	}, [params, getDetails]);

	const openLogPanel = (original) => {
		resetField("Exercises.toggleAddLogPanel", true);
		resetField("Exercises.exerciseToLog", { name: original.exercise_name, id: original.exercise });
		const values = { ...original, datedone: moment(original.datedone).format("YYYY-MM-DD") };
		delete values.calories;
		setFormValues(values);
	};

	const showUpdate = () => {
		getDetails(`?${params}`);
	};

	const handleDelete = (original) => {
		setDeleteItem(original);
	};

	const confirmEvent = (yes) => {
		const successHandler = (res) => {
			getDetails(`?${params}`);
		};
		if (yes && deleteItem) {
			deleteExerciseFromHistory(deleteItem, successHandler);
			setDeleteItem(null);
			setShowModal(false);
		} else {
			setDeleteItem(null);
		}
	};

	const columns = [
		{
			Header: "Exercise",
			accessor: "exercise_name",
			sortable: false,
			Cell: ({ original }) => <span> {original.exercise_name ? original.exercise_name : "-"} </span>
		},
		{
			Header: "Date",
			accessor: "datedone",
			sortable: false,
			Cell: ({ original }) => <span> {original.datedone ? moment(original.datedone).format("MMM D-YYYY") : " - "} </span>
		},
		{
			Header: "Minutes",
			accessor: "duration",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.duration ? original.duration : "-"} </span>
		},
		{
			Header: "Calories",
			accessor: "calories",
			className: "text-center",
			headerClassName: "text-center",
			sortable: false,
			Cell: ({ original }) => <span> {original.calories ? original.calories : "-"} </span>
		},
		{
			Header: "Notes",
			accessor: "notes",
			sortable: false,
			Cell: ({ original }) => <span> {original.notes ? original.notes : "-"} </span>
		},
		{
			Header: "Actions",
			accessor: "id",
			sortable: false,
			className: "text-right",
			headerClassName: "text-right",
			Cell: ({ original }) => (
				<div>
					<Tooltip content="Edit" placement="left">
						<button className="btn btn-success btn-ghost btn-cell btn-sm" onClick={() => openLogPanel(original)}>
							<i className="icon icon-edit" />
						</button>
					</Tooltip>
					<Tooltip content="Delete" placement="left">
						<button
							className="btn btn-danger btn-ghost btn-cell btn-sm ml-2"
							onClick={() => handleDelete(original)}>
							<i className="icon icon-trash" />
						</button>
					</Tooltip>
				</div>
			)
		}
	];

	const onPagination = (event) => {
		setParams(event);
	};

	return (
		<React.Fragment>
			<PaginatedTable
				data={detailsData.results}
				totalItems={detailsData.count}
				pageSize={15}
				prev={detailsData.prev}
				next={detailsData.next}
				onPagination={onPagination}
				columns={columns}
			/>

			<AddLogPanel history={history} initialValues={formValues} onUpdate={showUpdate} />
			<ConfirmDelete
				item={deleteItem ? deleteItem : showModal}
				message={<div>Are you sure you want to delete?</div>}
				onEvent={confirmEvent}
			/>
		</React.Fragment>
	);
};

const mapDispatchToProps = { getDetails, resetField, deleteExerciseFromHistory };

const mapStateToProps = (state) => {
	const { MyHistory } = state;
	return {
		detailsData: get(MyHistory, "details", [])
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Details);
